import {Component, Input, ViewChild} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {BaseComponent} from "../../base/base.component";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";
import {LookupService} from "../../srvs/lookup";
import {RegionAuditLogsComponent} from "../../sa/regions/regionAuditLogs.component";

@Component({
  selector: 'micro-saLock-stats',
  templateUrl: './saLockStats.component.html'
})
export class SaLockStatsComponent extends BaseComponent {

  companyId:any;
  stats:any = {};

  constructor(protected env: EnvService,
              protected http: HttpClient,
              protected authService:AuthService) {
    super(env, http);
    if (this.authService.isCompanyAdmin()) {
      this.companyId = undefined;
    } else {
      this.companyId = this.authService.getCompanyId();
    }
  }

  protected onInit(): void {
    this.loadStats();
  }

  public loadStats() {
    let params:HttpParams = new HttpParams();
    if (this.companyId) {
      params = params.set("forCompanyId", this.companyId)
    }

    this.http.get(`${this.env.e.url}/access/saLocks/stats`, {params:params}).subscribe(
      data => {
        this.stats = data;
      }
    );
  }

  onCompanyIdChanged() {
    this.loadStats();
  }

}
